import * as React from 'react';

import { iron, scienceBlue } from '../abstracts/colours';

export interface IconProps {
  fill?: string;
  disabled?: boolean;
  width?: number;
  height?: number;
}

const Logout: React.SFC<IconProps> = ({ fill = scienceBlue, disabled, width = 24, height = 25 }) => {
  const color = disabled ? iron : fill;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 25">
      <g>
        <path
          fill={color}
          d="M20.468 4.615c-1.119-1.126-3.05-.633-3.493.887-.242.826-.005 1.535.59 2.157 1.71 1.784 2.436 3.916 2.147 6.36-.532 4.498-4.886 7.56-9.354 6.608-4.027-.855-6.69-4.71-6.05-8.75.265-1.674 1.015-3.094 2.194-4.312.844-.873.797-2.184-.065-2.992-.853-.8-2.152-.763-2.985.112C.609 7.66-.507 11.195.212 15.23c1.16 6.495 7.501 10.792 13.99 9.557 5.704-1.085 9.764-5.952 9.798-11.727-.02-.327-.036-.655-.063-.98-.247-2.908-1.412-5.397-3.47-7.466z"
        />
        <path
          fill={color}
          d="M10.005 7.994c0 1.998-.009 3.959.003 5.937.007 1.139.92 2.07 1.99 2.069 1.072-.002 1.991-.924 1.994-2.065.01-3.956.01-7.913 0-11.869 0-.541-.198-1.008-.544-1.399-.56-.633-1.424-.838-2.182-.518-.759.32-1.259 1.1-1.264 1.972-.005 1.958 0 3.923 0 5.872h.003z"
        />
      </g>
    </svg>
  );
};

export default Logout;
